import { render } from "./ReroptDetailCalls.vue?vue&type=template&id=229060af"
import script from "./ReroptDetailCalls.vue?vue&type=script&lang=js"
export * from "./ReroptDetailCalls.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__